var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sleep } from "nate-react-api-helpers";
const transientStatuses = [502, 503, 504]; // true for failures caused by the backend being unreachable or restarting (gateway errors, network errors).
// Errors returned by the backend itself (e.g. 400/500 with a json error body) are not transient.
export function isTransientError(e) {
    var _e$info$response$stat, _e$info, _e$info$response, _e$info2, _e$info2$xhr;
    if (e instanceof TypeError)
        return true; // fetch network failure
    const status = (_e$info$response$stat = e === null || e === void 0 ? void 0 : (_e$info = e.info) === null || _e$info === void 0 ? void 0 : (_e$info$response = _e$info.response) === null || _e$info$response === void 0 ? void 0 : _e$info$response.status) !== null && _e$info$response$stat !== void 0 ? _e$info$response$stat : e === null || e === void 0 ? void 0 : (_e$info2 = e.info) === null || _e$info2 === void 0 ? void 0 : (_e$info2$xhr = _e$info2.xhr) === null || _e$info2$xhr === void 0 ? void 0 : _e$info2$xhr.status;
    return transientStatuses.includes(status);
} // retries callback on transient errors, waiting delaysMs[i] before retry i
export function retryTransient(callback) {
    var arguments_1 = arguments;
    return __awaiter(this, void 0, void 0, function* () { let delaysMs = arguments_1.length > 1 && arguments_1[1] !== undefined ? arguments_1[1] : [500, 1000, 1500, 2000, 2000, 2500, 2500, 3000]; for (let i = 0;; i++) {
        try {
            return yield callback();
        }
        catch (e) {
            if (i >= delaysMs.length || !isTransientError(e))
                throw e;
            yield sleep(delaysMs[i]);
        }
    } });
}
